import { ConnectError } from "@bufbuild/connect";

import { REGION_HEADER_KEY, SC_REFERENCE_HEADER_KEY } from "./constants";
import { RequestMetadata } from "./types";

export const callOptionsHeaders = (region: string, referenceID?: string) => {
  if (referenceID === undefined) {
    referenceID = "";
  }

  const headers: Record<RequestMetadata, string> = {
    [REGION_HEADER_KEY]: region,
    [SC_REFERENCE_HEADER_KEY]: referenceID,
  };

  return headers;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isConnectError(error: any): error is ConnectError {
  return !!error && error instanceof ConnectError;
}
